import React from 'react';
import { Badge } from '@cargomatic/ui';
import { humanize } from 'underscore.string';
import { format } from 'date-fns';
import { CircleCheckIcon, CircleSlashIcon } from 'lucide-react';
import moment from 'moment';
import StatusBadge from './StatusBadge';
import { CustomerTypeBadge } from './CustomerTypeBadge';
import _ from 'lodash';
export const formatStatusCell = ({ row }) => {
    const value = row.getValue('status');
    return React.createElement(StatusBadge, { status: value });
};
export function formatBooleanValue(value) {
    if (value) {
        return (React.createElement("div", { className: "flex justify-end text-right" },
            React.createElement(CircleCheckIcon, { className: "w-4 h-4 text-green-500 text-right" })));
    }
    if (value === false) {
        return (React.createElement("div", { className: "flex justify-end text-right" },
            React.createElement(CircleSlashIcon, { className: "w-4 h-4 text-red-500 text-right" })));
    }
    return null;
}
export function formatTextValue(value) {
    return value || '-';
}
export function formatNumericValue(value) {
    return React.createElement("div", { className: "text-right" }, value || '-');
}
export const formatSequenceCell = ({ row }) => {
    const sequence = row.original.sequenceCount;
    const sequenceCount = row.original.totalCount;
    if (!sequence || !sequenceCount) {
        return '-';
    }
    return `${sequence} of ${sequenceCount} `;
};
export const formatCustomerTypeCell = ({ row }) => {
    const value = row.getValue('customerType');
    return React.createElement(CustomerTypeBadge, { customerType: value });
};
export function formatCustomerCell({ row }) {
    return formatTextValue(row.getValue('customerName'));
}
export const formatRateCell = ({ row }) => {
    const rateValue = row.getValue('rate');
    if (!rateValue) {
        return formatNumericValue('-');
    }
    const amount = parseFloat(row.getValue('rate')).toFixed(2);
    const formatted = new Intl.NumberFormat('en-us', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
    return formatNumericValue(formatted);
};
function formatDateCell(date) {
    const value = date ? format(date, 'MM/dd/yyyy') : '-';
    return formatNumericValue(value);
}
export const formatUpdatedAtCell = ({ row }) => {
    const rowValue = row.getValue('laneRatesUpdatedAt');
    return rowValue ? moment(rowValue).fromNow(true) : '-';
};
export const formatCreatedAtCell = ({ row }) => {
    const rowValue = row.getValue('laneRatesCreatedAt');
    return formatDateCell(rowValue);
};
export const formatValidityStart = ({ row }) => {
    const rowValue = row.getValue('effectiveStart');
    return formatDateCell(rowValue);
};
export const formatValidityEnd = ({ row }) => {
    const rowValue = row.getValue('effectiveEnd');
    return formatDateCell(rowValue);
};
export const formatReversibleCell = ({ row }) => {
    const reversible = row.getValue('reversible');
    return formatBooleanValue(reversible);
};
export const formatBillRoundtripeCell = ({ row }) => {
    const rowValue = row.getValue('billRoundtrip');
    return formatBooleanValue(rowValue);
};
export const formatCommittmentCell = ({ row }) => {
    const value = row.getValue('commitment');
    return formatNumericValue(value);
};
export function getRateConditions(row) {
    var _a;
    return ((_a = row.original) === null || _a === void 0 ? void 0 : _a.conditions) || {};
}
export function formatHazardous(criteria) {
    if (_.isEmpty(criteria))
        return criteria;
    return criteria === 'Y' ? 'Yes' : 'No';
}
export function getRateConditionCriteria(key, row) {
    var _a, _b;
    const criteria = (_b = (_a = getRateConditions(row)) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.criteria;
    if (['hazmat', 'hazardous'].includes(key))
        return formatHazardous(criteria);
    return criteria;
}
export const formatCustomerRateConditionCell = ({ row }) => formatTextValue(getRateConditionCriteria('customer', row));
export const formatEquipmenSizeRateConditionCell = ({ row }) => (React.createElement("div", { className: "text-right" }, formatTextValue(getRateConditionCriteria('equipmentSize', row))));
export const formatEquipmenTypeRateConditionCell = ({ row }) => formatTextValue(getRateConditionCriteria('equipmentType', row));
export const formatHazmatRateConditionCell = ({ row }) => formatTextValue(getRateConditionCriteria('hazmat', row));
export const formatMarketRateConditionCell = ({ row }) => formatTextValue(getRateConditionCriteria('market', row));
export const formatOrderTypeRateConditionCell = ({ row }) => formatTextValue(getRateConditionCriteria('orderType', row));
export const formatSteamshipLineRateConditionCell = ({ row }) => formatTextValue(getRateConditionCriteria('steamShipLine', row));
